import React from 'react';

import { Modal } from '@iwoca/orion';

import styles from './EditModal.module.css';

class EditModal extends React.Component {
    static defaultProps = {
        mandatory: false
    };

    state = {
        handleHide: null
    };

    // HOC Drill Pattern
    // used to pass the onClose behaviour to onHide Modal method
    handleHideCallback = (onClose) => {
        this.setState({
            handleHide: onClose
        });
    };

    unregisterHideCallback = () => {
        this.setState({
            handleHide: null
        });
    };

    render() {
        const { isOpen, mandatory } = this.props;

        return (
            <Modal
                data-testid="edit-modal-container"
                isOpen={isOpen}
                onClose={this.handleHideCallback}
                className={styles.modalContainer}>
                {React.cloneElement(this.props.children, {
                    handleHideCallback: this.handleHideCallback,
                    unregisterHideCallback: this.unregisterHideCallback,
                    mandatory
                })}
            </Modal>
        );
    }
}

export default EditModal;
